export default "__VITE_ASSET__e14dde2d__"